import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL_ELITE_VACANCES_PRIORITY;

const apiConfig = axios.create({
  baseURL: baseUrl,
  headers: { "Content-Type": "application/json" },
});
// Interceptor de solicitud (agregar el token a todas las solicitudes)
apiConfig.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Obtener token del localStorage (o donde lo guardes)
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor de respuesta (manejar errores globales como token inválido)
apiConfig.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si el token es inválido (401) y no hemos intentado refrescarlo, limpiamos datos y redirigimos al login
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // Limpiar datos (por ejemplo, eliminar el token)
      localStorage.clear();
      window.location.href = "/"; // Redirigir al login
    }

    return Promise.reject(error);
  },
);

export default apiConfig;
